import { DraggableProvidedDragHandleProps } from "@hello-pangea/dnd";
import { StorageOutlined } from "@mui/icons-material";
import { Stack, Tooltip } from "@mui/material";
import { KNOWLEDGE_BLOCKS_IDS_PARAM_NAME } from "constants/global";
import AccordionTextFieldControl from "hocs/withAccordion/AccordionTextFieldControl";
import withSelectionCheckbox, { WithSelectionCheckboxInjectedProps } from "hocs/withSelectionCheckbox";
import { useContext, useState } from "react";
import { useFieldArray, UseFormReturn } from "react-hook-form";
import withAccordion from "../../../../../hocs/withAccordion";
import { CompetencyLiteralType, CompetencyMapInputs } from "../types";
import KnowledgeBlockBody from "./KnowledgeBlockBody";
import KnowledgeBlockCreation from "./KnowledgeBlockCreation";

interface AccordionSummaryTitleProps {
  name: string;
  isEditable: boolean;
}

const AccordionSummaryTitle = ({
  isEditable,
  name,
  selectionCheckboxNode,
}: AccordionSummaryTitleProps & WithSelectionCheckboxInjectedProps) => {
  return (
    <Stack
      direction='row'
      spacing={1}
      alignItems='center'>
      {selectionCheckboxNode}
      <Tooltip title='Блок знаний'>
        <StorageOutlined fontSize='small' />
      </Tooltip>
      <AccordionTextFieldControl
        placeholder='Название'
        name={`${name}.title`}
        disabled={!isEditable}
        disabledViewAsText
      />
    </Stack>
  );
};

const AccordionSummaryTitleWithSelectionCheckbox = withSelectionCheckbox(AccordionSummaryTitle);

const KnowledgeBlockBodyWithAccordion = withAccordion(KnowledgeBlockBody);

interface KnowledgeBlockProps {
  knowledgeBlockId: string | undefined;
  name: CompetencyLiteralType;
  isEditable: boolean;
  form: UseFormReturn<CompetencyMapInputs>;
  dragHandleProps: DraggableProvidedDragHandleProps | null;
  onRemove: () => void;
}

const KnowledgeBlock = ({
  knowledgeBlockId,
  name,
  isEditable,
  form,
  dragHandleProps,
  onRemove,
}: KnowledgeBlockProps) => {
  const [isCreation] = useState(!knowledgeBlockId);
  const { control } = form;
  const skillsArray = useFieldArray({
    control,
    name: `${name}.skills`,
    keyName: "skillId",
  });
  const {
    fields: skillsFields,
    append: appendSkill,
    replace: replaceSkills,
    remove: removeSkill,
    move: moveSkill,
  } = skillsArray;

  if (isCreation)
    return (
      <KnowledgeBlockCreation
        name={name}
        isEditable={isEditable}
        form={form}
        onRemove={onRemove}
        appendSkill={appendSkill}
        replaceSkills={replaceSkills}
        removeSkill={removeSkill}
        moveSkill={moveSkill}
        dragHandleProps={dragHandleProps}
        skillsFields={skillsFields}
      />
    );

  return (
    <KnowledgeBlockBodyWithAccordion
      accordionSummaryTitle={
        <AccordionSummaryTitleWithSelectionCheckbox
          isEditable={isEditable}
          name={name}
          selectionEntity={knowledgeBlockId ? { type: "knowledgeBlock", id: knowledgeBlockId } : undefined}
        />
      }
      name={name}
      sx={{ backgroundColor: "bgSwitch", boxShadow: "none" }}
      isEditable={isEditable}
      form={form}
      entityId={knowledgeBlockId}
      idsSearchParamName={KNOWLEDGE_BLOCKS_IDS_PARAM_NAME}
      onRemove={isEditable ? onRemove : undefined}
      appendSkill={appendSkill}
      removeSkill={removeSkill}
      moveSkill={moveSkill}
      dragHandleProps={dragHandleProps}
      skillsFields={skillsFields}
    />
  );
};

export default KnowledgeBlock;
